var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container container-small" }, [
    !_vm.loading
      ? _c(
          "div",
          { staticClass: "mt-sm-3" },
          [
            _c("div", [
              _c("div", { staticClass: "panels" }, [
                _c("div", { staticClass: "form-group panel" }, [
                  _c("label", { attrs: { for: "newAccountEmail" } }, [
                    _vm._v(_vm._s(_vm.$t("label_email"))),
                  ]),
                  _c("br"),
                  _vm._v(" " + _vm._s(_vm.user.email) + " "),
                ]),
                _c(
                  "div",
                  { staticClass: "panel form-group" },
                  [
                    !_vm.showEditPassword
                      ? [
                          _c(
                            "label",
                            { attrs: { for: "newAccountPassword" } },
                            [_vm._v(_vm._s(_vm.$t("label_password")))]
                          ),
                          _c("div", [_vm._v("*********")]),
                        ]
                      : _vm._e(),
                    !_vm.user.social_account
                      ? _c(
                          "a",
                          {
                            staticClass: "link d-block",
                            on: {
                              click: function ($event) {
                                return _vm.togglePasswordEdit()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("btn_edit_password")))]
                        )
                      : _vm._e(),
                    _vm.showEditPassword
                      ? [
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "label",
                              { attrs: { for: "newAccountPassword" } },
                              [_vm._v(_vm._s(_vm.$t("label_password")))]
                            ),
                            _c("span", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                " " + _vm._s(_vm.errorMsgs.password) + " "
                              ),
                            ]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.password,
                                  expression: "password",
                                },
                              ],
                              staticClass: "form-control",
                              class: { "has-error": _vm.errorMsgs.password },
                              attrs: { type: "password" },
                              domProps: { value: _vm.password },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.password = $event.target.value
                                },
                              },
                            }),
                          ]),
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "label",
                              {
                                attrs: {
                                  for: "newAccountPasswordConfirmation",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("label_confirm_password")))]
                            ),
                            _c("span", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                " " + _vm._s(_vm.errorMsgs.passwordVerify) + " "
                              ),
                            ]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.passwordVerify,
                                  expression: "passwordVerify",
                                },
                              ],
                              staticClass: "form-control",
                              class: {
                                "has-error": _vm.errorMsgs.passwordVerify,
                              },
                              attrs: { type: "password" },
                              domProps: { value: _vm.passwordVerify },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.passwordVerify = $event.target.value
                                },
                              },
                            }),
                          ]),
                          _c("div", { staticClass: "action-button" }, [
                            _c(
                              "button",
                              {
                                staticClass: "main-btn",
                                class: { disabled: _vm.saveBtnDisabled },
                                attrs: {
                                  type: "submit",
                                  disabled: _vm.saveBtnDisabled,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.validate()
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("btn_edit")))]
                            ),
                          ]),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "panel form-group" },
                  [
                    !_vm.showEditPhone
                      ? [
                          _c("label", { attrs: { for: "newAccountPhone" } }, [
                            _vm._v(_vm._s(_vm.$t("label_phone"))),
                          ]),
                          _vm.user.phone
                            ? _c("div", [_vm._v(_vm._s(_vm.user.phone))])
                            : _vm._e(),
                        ]
                      : _vm._e(),
                    !_vm.user.social_account
                      ? _c(
                          "a",
                          {
                            staticClass: "link d-block",
                            on: {
                              click: function ($event) {
                                return _vm.togglePhoneEdit()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("btn_edit_phone")))]
                        )
                      : _vm._e(),
                    _vm.showEditPhone
                      ? [
                          _c("div", { staticClass: "row align-items-end" }, [
                            _c(
                              "div",
                              { staticClass: "col-md col-12 pb-3 pb-md-0" },
                              [
                                _c("div", { staticClass: "form-group" }, [
                                  _c(
                                    "label",
                                    { attrs: { for: "newAccountPassword" } },
                                    [_vm._v(_vm._s(_vm.$t("label_phone")))]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.errorMsgs.phone) + " "
                                      ),
                                    ]
                                  ),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.phone,
                                        expression: "phone",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    class: { "has-error": _vm.errorMsgs.phone },
                                    attrs: { type: "tel" },
                                    domProps: { value: _vm.phone },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) return
                                          _vm.phone = $event.target.value
                                        },
                                        _vm.isNumber,
                                      ],
                                    },
                                  }),
                                ]),
                              ]
                            ),
                            _c("div", { staticClass: "col-md col-12" }, [
                              _c("div", { staticClass: "action-button" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "main-btn",
                                    class: { disabled: _vm.saveBtnDisabled },
                                    attrs: {
                                      type: "submit",
                                      disabled: _vm.saveBtnDisabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.validate()
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("btn_save")))]
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
            ]),
            _vm.showSuccessMsg
              ? [
                  _c("br"),
                  _c("div", { staticClass: "pb-3" }, [
                    _c(
                      "div",
                      { staticClass: "alert alert-success text-center" },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("data_saved_succesfully")) + "! "
                        ),
                      ]
                    ),
                  ]),
                ]
              : _vm._e(),
            _c(
              "div",
              {
                staticClass:
                  "pt-4 d-flex d-md-block justify-content-between pb-3",
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "custom-link pointer d-block d-md-none",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.doLogout()
                      },
                    },
                  },
                  [_vm._v(" Logout")]
                ),
                _c("div", { staticClass: "text-right" }, [
                  _c(
                    "span",
                    {
                      staticClass: "text-danger pointer",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.deleteAccount()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fa fa-trash" }),
                      _vm._v(" " + _vm._s(_vm.$t("btn_delete_account"))),
                    ]
                  ),
                ]),
                _vm.deleteAccountRequest
                  ? _c(
                      "div",
                      {
                        staticClass: "alert text-center",
                        class: {
                          "alert-success": _vm.deleteRequestDoesntExist,
                          "alert-danger": !_vm.deleteRequestDoesntExist,
                        },
                      },
                      [
                        !_vm.deleteRequestDoesntExist
                          ? [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "delete_request_already_sent_message"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          : _vm._e(),
                        _vm.deleteRequestDoesntExist
                          ? [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("delete_request_sent_message")
                                  ) +
                                  " "
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
              ]
            ),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }